$(document).ready(function () {
    if(window.smeg && window.smeg.courses){
        $('#calendar-container').simpleCalendar({
                events: window.smeg.courses.events,
            }
        );
    }
});